'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { SeparatorTitle } from '../../component/separator-title';
import { BriefInfo } from '../milestone/brief-info';
import { GaugeArea } from '../milestone/gauge-area';
import { MilestoneDataSourceContext, milestoneBunja } from '../milestone/state';
import { pricePredictionMilestoneDataSourceBunja } from './state';

export const PricePredictionMilestone = () => {
  const { dataSource } = useBunja(pricePredictionMilestoneDataSourceBunja);

  if (!dataSource) return null;

  return (
    <MilestoneDataSourceContext.Provider value={dataSource}>
      <PricePredictionMilestoneContent />
    </MilestoneDataSourceContext.Provider>
  );
};

const PricePredictionMilestoneContent = () => {
  const { milestonesAtom, maxPrizePoolAtom, isUpcomingAtom, isOngoingAtom } = useBunja(milestoneBunja);
  const milestones = useAtomValue(milestonesAtom);
  const maxPrizePool = useAtomValue(maxPrizePoolAtom);
  const isUpcoming = useAtomValue(isUpcomingAtom);
  const isOngoing = useAtomValue(isOngoingAtom);

  if (milestones.length === 0) return null;

  if (isUpcoming) {
    return (
      <section className={stack({ gap: { base: 40, tablet: 16 }, alignSelf: 'stretch' })}>
        <SeparatorTitle
          colorSet='normal'
          subtitle={<FormattedMessage id='Campaign.r260123.Daily_volume_milestones' />}
          title={
            <FormattedMessage
              id='Competition.r251215.Trade_big_win_amount'
              values={{ amount: <Formatted.ShortNumber value={maxPrizePool} /> }}
            />
          }
        />
        <div
          className={stack({
            px: 24,
            pt: 32,
            pb: 54,
            gap: 64,
            rounded: 16,
          })}
        >
          <GaugeArea />
        </div>
      </section>
    );
  }

  return (
    <section
      className={stack({ gap: 32, alignSelf: 'stretch', alignItems: 'stretch', mt: 24, mb: { base: 80, tablet: 120 } })}
    >
      <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5', textAlign: 'left' })}>
        {isOngoing ? (
          <FormattedMessage id='Competition.r251215.Increase_prize_pool_together' />
        ) : (
          <FormattedMessage id='Competition.r251215.Milestone_final_results' />
        )}
      </p>
      <BriefInfo milestoneType='daily' />
      <GaugeArea />
    </section>
  );
};
